"use client"

import type { HTMLStyledProps, ThemeProps } from "@/components/ui"
import type { InputProps } from "./input"
import type { InputElementStyle } from "./input-element.style"
import { createComponent } from "@/components/ui"
import { inputElementStyle } from "./input-element.style"
import { useInputBorder } from "./use-input-border"

export interface InputElementProps
  extends HTMLStyledProps,
    ThemeProps<InputElementStyle>,
    Pick<InputProps, "errorBorderColor" | "focusBorderColor"> {}

const {
  PropsContext: InputElementPropsContext,
  usePropsContext: useInputElementPropsContext,
  withContext,
} = createComponent<InputElementProps, InputElementStyle>(
  "input-element",
  inputElementStyle,
)

export { InputElementPropsContext, useInputElementPropsContext }

export const InputElement = withContext("div")(
  { "data-input-element": "" },
  ({ errorBorderColor, focusBorderColor, ...rest }) => {
    const varProps = useInputBorder({ errorBorderColor, focusBorderColor })

    return { ...varProps, ...rest }
  },
)
